import React, { useEffect, useRef, useState } from "react";
import { Modal, ModalProps } from "@arco-design/web-react";
import CustomVideo from "@/pages/CreateVideo/component/VideoCompont/videoany";
import "./PlayerModal.less";

export type ContentType = "video" | "music" | "picture";

export interface IPlayModal extends ModalProps {
  playUrl: string;
  name: string;
  type: ContentType;
}

const toTypeGetHeight = (type: ContentType) => {
  switch (type) {
    case "video":
      return "500px";
      break;
    case "picture":
      return "500px";
    case "music":
      return "120px";
    default:
      return "";
  }
};

const PlayerModal: React.FC<IPlayModal> = (props) => {
  const { playUrl, name, type, ...res } = props;
  return (
    <Modal
      {...res}
      footer={null}
      title={name}
      className={"_video-wrapper-modal"}
      style={{ width: 700, height: toTypeGetHeight(type) }}>
      {type === "video" ? (
        <div className="_play-content">
          {playUrl ? (
            <video
              controls={true}
              src={playUrl || null}
              style={{ width: "100%", height: "432px", background: "black" }}
            />
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
      {type === "picture" ? (
        <div className="_picture-wrapper">
          <img
            style={{
              maxHeight: "calc(100% - 20px)",
              maxWidth: "calc(100% - 20px)",
              margin: "10px",
              marginTop: "0px",
              objectFit: "contain",
            }}
            src={playUrl}
            alt=""
          />
        </div>
      ) : (
        <></>
      )}
      {type === "music" ? (
        <>
          <audio
            src={playUrl}
            controls
            style={{ width: "calc(100% - 20px)", marginLeft: "10px" }}></audio>
        </>
      ) : (
        <></>
      )}
    </Modal>
  );
};

export default PlayerModal;
